import cc from 'classcat';
import { observer } from 'mobx-react';
import * as React from 'react';
import { match, RouteComponentProps, withRouter } from 'react-router';
import { NavLink } from 'react-router-dom';
import { YearData } from '../stores/YearData';
import styles from './YearLink.styl';

interface YearLinkProps {
    year: Partial<YearData>;
    path: string;
    className?: string;
}

@(withRouter as ClassDecorator)
@observer
export class YearLink extends React.Component<YearLinkProps & Partial<RouteComponentProps<{ year: string }>>> {
    private checkActive = (match: match) => {
        const { year } = this.props;
        const isActive = !!match;
        const stateChanged = year.setRef && year.isActive !== isActive;
        if (stateChanged) {
            year.setActive(isActive);
            if (isActive) {
                year.scrollIntoView();
            }
        }
        return isActive;
    };

    render() {
        const { year, path, className } = this.props;
        const { isVisible, text, value } = year;
        return (
            <div ref={year.setRef}>
                <NavLink
                    to={`${path}/${value}`}
                    className={cc([
                        styles.year,
                        {
                            [styles.visible]: isVisible,
                            [styles.invisible]: !isVisible,
                        },
                        className,
                    ])}
                    activeClassName={styles.active}
                    isActive={this.checkActive}
                >
                    <span>{text}</span>
                </NavLink>
            </div>
        );
    }
}

@observer
export class ActiveYearLink extends React.Component<YearLinkProps & { side: 'left' | 'right' }> {
    render() {
        const { year, path, side } = this.props;

        if (!year || !side || year.isVisible) return null;

        const className = cc([
            styles.absolute,
            {
                [styles.left]: side === 'left',
                [styles.right]: side === 'right',
            },
        ]);

        const { isActive, value, text, scrollIntoView } = year;
        const yearCopy = { isActive, isVisible: year.isVisible, value, text, scrollIntoView, setActive: Stub };
        return (
            <YearLink year={yearCopy} path={path} className={className} />
        );
    }
}

const Stub: any = () => {};
